import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type AttachFileProps = IconComponentBaseProps;

export const AttachFile = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: AttachFileProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_4384_14713"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4384_14713)">
        <path
          d="M11.7828 10.4295C11.7828 11.5121 11.4061 12.4334 10.6527 13.1933C9.89934 13.9533 8.98228 14.3333 7.90151 14.3333C6.82073 14.3333 5.90256 13.9533 5.14701 13.1933C4.39145 12.4334 4.01367 11.5121 4.01367 10.4295V4.43579C4.01367 3.66657 4.28078 3.01274 4.81501 2.47429C5.34912 1.93585 6.00078 1.66663 6.77001 1.66663C7.53923 1.66663 8.19095 1.93585 8.72517 2.47429C9.25939 3.01274 9.5265 3.66657 9.5265 4.43579V10.109C9.5265 10.5602 9.36934 10.9454 9.05501 11.2646C8.74056 11.5838 8.35745 11.7435 7.90567 11.7435C7.45378 11.7435 7.06823 11.585 6.74901 11.268C6.42978 10.951 6.27017 10.5646 6.27017 10.109V4.75646C6.27017 4.61479 6.31806 4.49601 6.41384 4.40013C6.50973 4.30435 6.62856 4.25646 6.77034 4.25646C6.91201 4.25646 7.03073 4.30435 7.12651 4.40013C7.22217 4.49601 7.27001 4.61479 7.27001 4.75646V10.109C7.27001 10.2876 7.33006 10.4381 7.45017 10.5603C7.57028 10.6825 7.71967 10.7436 7.89834 10.7436C8.07689 10.7436 8.22623 10.6825 8.34634 10.5603C8.46645 10.4381 8.52651 10.2876 8.52651 10.109V4.42946C8.51962 3.93713 8.34862 3.52024 8.01351 3.17879C7.67839 2.83735 7.26389 2.66663 6.77001 2.66663C6.27823 2.66663 5.86256 2.8384 5.52301 3.18196C5.18345 3.52563 5.01367 3.94357 5.01367 4.43579V10.4295C5.00678 11.2355 5.28539 11.9209 5.84951 12.4858C6.41362 13.0508 7.09839 13.3333 7.90384 13.3333C8.69784 13.3333 9.37278 13.0508 9.92867 12.4858C10.4844 11.9209 10.7692 11.2355 10.7828 10.4295V4.75646C10.7828 4.61479 10.8308 4.49601 10.9267 4.40013C11.0226 4.30435 11.1414 4.25646 11.2832 4.25646C11.4248 4.25646 11.5436 4.30435 11.6393 4.40013C11.735 4.49601 11.7828 4.61479 11.7828 4.75646V10.4295Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
